export const environment = {
  duuUploadBucket : 'bridge-prod-bucket-duu-zip-upload',
  identityPoolId:  'us-east-2:b6337503-b810-4bba-b30e-cdb054afc893',
  s3_endpoint: '',
  sts_endpoint: '',
  s3_downUrl: 'https://s3.amazonaws.com',
  appVersion: 'Version 1.0.0',
  baseUrl: 'https://api.prod.snncloudservices.com',
  baseUrlClp: 'https://api.prod.snncloudservices.com',
  baseUrlClpSnn: 'https://api-snn.prod.snncloudservices.com',
  baseUnauthUrl: 'https://api2.prod.snncloudservices.com',
  userPoolAwsLogin:  'cognito-idp.us-east-2.amazonaws.com/us-east-2_myOjAxMgN',
  production: true,
  lensSenderEmail: 'snnoreply@maildrop.cc',
  region: 'us-east-2',
  apiVersionCognito: '2016-04-18',
  apiVersionSqs: '2012-11-05',
  lambdaFunction: {
    bridgeDuuProcessZipUpload: 'bridge-prod-duu-process-zip-upload',
    lambdaRegion: 'us-east-2'
  },
  ssmParams: {
    IDLETIME: "/bridge-prod/image-upload-service_prod/inactivityTime_login",
    DIACOMTAG: "/bridge-prod/image-upload-service_prod/validDicomTags",
    RECALLTIME: "/bridge-prod/image-upload-service_prod/recallTime",
    AUDITINTERVALTIME: "/bridge-prod/image-upload-service_prod/auditInterval",
    APPDIACOMTAGSCRIPT: "/bridge-prod/image-upload-service_prod/validApplicationDicomTags",
    APPVERSION: "/bridge-prod/image-upload-service_prod/appVersionInfo",
    SQSQUEUEURL: "/bridge-prod/DUU_Group_by_patient/group-by-patient-queue-url",
    APPNAME: "/bridge-prod/DUU_app_name/appName",
    IFUCONTENT:"/bridge-prod/image-upload-service_prod/IFUContent"
  },
  //ALL ROLES EXPECT SNN
  clp: {
    hostedUIUrl: "https://bridge-prod-clp-auth.auth.us-east-2.amazoncognito.com/oauth2/",
    hostedUIlogout: "https://bridge-prod-clp-auth.auth.us-east-2.amazoncognito.com/logout",
    identityPoolId: "us-east-2:b6337503-b810-4bba-b30e-cdb054afc893",
    userPoolId: "us-east-2_myOjAxMgN",
    userPoolWebClientId: "4hs57qnirdle4et6v78qhuldti",
    userPoolAwsLogin: "cognito-idp.us-east-2.amazonaws.com/us-east-2_myOjAxMgN",
    cloudfrontCLPURL: 'https://snncloudservices.com',
    cloudFrontCLPSignInUrl: 'https://snncloudservices.com/signin',
    cloudFrontCLPSignOutUrl: 'https://snncloudservices.com/logout',
    cloudFrontCLPExitAppUrl: 'https://snncloudservices.com/application/product',
  },
  //SNN ROLE
  snnClp: {
    hostedUIUrl: "https://bridge-prod-snn-auth.auth.us-east-2.amazoncognito.com/oauth2/",
    hostedUIlogout: "https://bridge-prod-snn-auth.auth.us-east-2.amazoncognito.com/logout",
    identityPoolId: "us-east-2:d31817c1-e4dd-43cc-9a3f-c36f2e9108b8",
    userPoolId: "us-east-2_Xq5m1dKjs",
    userPoolWebClientId: "6eakepqap8sjlghobbommjl6lh",
    userPoolAwsLogin: "cognito-idp.us-east-2.amazonaws.com/us-east-2_Xq5m1dKjs",
    cloudfrontCLPURL: 'https://snn.snncloudservices.com',
    cloudFrontCLPSignInUrl: 'https://snn.snncloudservices.com/signin',
    cloudFrontCLPSignOutUrl: 'https://snn.snncloudservices.com/logout',
    cloudFrontCLPExitAppUrl: 'https://snn.snncloudservices.com/application/product',
  },
  duuCloudFrontSigninUrl: 'https://dataupload.snncloudservices.com/signin',
};
